import { render } from "./CldrUser.vue?vue&type=template&id=59c08be4&scoped=true"
import script from "./CldrUser.vue?vue&type=script&lang=js"
export * from "./CldrUser.vue?vue&type=script&lang=js"

import "./CldrUser.vue?vue&type=style&index=0&id=59c08be4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c08be4"]])

export default __exports__